import type { CSSProperties } from 'react';

/**
 * Data-driven CSS custom properties — the only inline style the design allows
 * (`--h`, `--w`, `--pos`, `--x`, `--y`, `--top`, `--risk`, `--a`, `--c`).
 */
export function cssVars(vars: Record<string, string | number>): CSSProperties {
  return Object.fromEntries(Object.entries(vars).map(([key, value]) => [`--${key}`, value]));
}
